import React, { useState, useEffect } from "react"
import Page from "../../common/page/Page"
import Form from "../../common/form/Form"
import { Link, useNavigate, useLocation } from "react-router-dom"
import axios from "axios"
import Loader from "../../common/loader/Loader"
import styles from "../../common/form/form.module.css"

const ActivateAccount = () => {
  const navigator = useNavigate()
  const location = useLocation()

  const [token, setToken] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [loading, setLoading] = useState(false)
  const [tokenFromUrl, setTokenFromUrl] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tokenParam = params.get("token")
    if (tokenParam) {
      setToken(tokenParam)
      setTokenFromUrl(true)
    }
  }, [location])

  const handleChange = (e) => {
    setToken(e.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess("")

    if (!token) {
      setError("Activation token is required.")
      return
    }

    try {
      setLoading(true)
      const response = await axios.post("api/auth/activate-account", {
        token,
      })

      setSuccess(response.data.message)
      setToken("")

      setTimeout(() => {
        navigator("/login")
      }, 3000)
    } catch (err) {
      console.error("Activation error:", err)
      if (err.response) {
        setError(err.response.data.error || "Activation failed.")
      } else {
        setError("Network error, please try again.")
      }
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  return (
    <Page title={"Activate Account"} searchDisabled={true}>
      {loading ? (
        <div style={{ display: "flex", height: "calc(80vh - 100px)" }}>
          <Loader />
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <div className={styles.cardContainer}>
            <div className={styles.cardHeader}>
              <h2>Account Activation</h2>
              <p>Verify your token to activate your account</p>
              <div className={styles.quote}>
                "Step into your personalized wellness space."
              </div>
            </div>

            {!tokenFromUrl && (
              <div>
                <label htmlFor="activation_token">Activation Token</label>
                <input
                  type="text"
                  id="activation_token"
                  name="token"
                  placeholder="Paste activation token here"
                  value={token}
                  onChange={handleChange}
                />
              </div>
            )}

            {error && <div className={styles.errorBanner}>{error}</div>}
            {success && <div className={styles.successBanner}>{success}</div>}

            <div>
              <button type="submit">Activate Account</button>
            </div>

            <div className={styles.linkBox}>
              <p>
                Already activated? <Link to={"/login"}>Sign In</Link>
              </p>
            </div>
          </div>
        </Form>
      )}
    </Page>
  )
}

export default ActivateAccount
